var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lite-switcher",on:{"click":_vm.onClick}},[_c('div',{class:{
        'switch': true,
        'lite': true,
        'switch-active': !!_vm.value
      }},[_vm._v("Lite")]),_c('div',{class:{
        'switch': true,
        'pro': true,
        'switch-active': !_vm.value
      }},[_vm._v("Pro")])])}
var staticRenderFns = []

export { render, staticRenderFns }